import menu from './menu'
import error from './error'
import cardSelect from './cardSelect'
import iframe from './iframe'
import subscription from './subscription'

export default {
    menu,
    error,
    cardSelect,
    iframe,
    subscription,


    yes: "Ja",
    no: "Nein",

    on: "An",
    off: "Aus"

}
